var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90275 2.78556C12.4388 0.248563 16.5578 0.248563 19.0948 2.78556C21.6318 5.32156 21.6318 9.44056 19.0948 11.9776C16.5578 14.5146 12.4388 14.5146 9.90275 11.9776C7.36575 9.44056 7.36575 5.32156 9.90275 2.78556ZM11.8998 5.03756C10.6588 6.41056 10.7008 8.53356 12.0238 9.85656C13.3898 11.2226 15.6078 11.2226 16.9738 9.85656C18.3398 8.49056 18.3398 6.27256 16.9738 4.90656C15.6078 3.54056 13.3898 3.54056 12.0238 4.90656L11.8998 5.03756Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56369 10.1992C9.56369 10.1992 3.84969 15.9122 1.43169 18.3312C0.845688 18.9162 0.845688 19.8662 1.43169 20.4522L1.43269 20.4532C2.01769 21.0382 2.96669 21.0382 3.55169 20.4532C5.96869 18.0362 11.6847 12.3202 11.6847 12.3202L9.56369 10.1992Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56625 15.332L3.03125 18.868C3.03125 18.868 5.09225 20.929 6.06725 21.904C6.34325 22.18 6.79025 22.18 7.06625 21.904C7.73925 21.231 8.93025 20.04 9.60325 19.367C9.87825 19.091 9.87825 18.644 9.60325 18.368C8.62825 17.394 6.56625 15.332 6.56625 15.332Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon_key.5deb8f0d4fab54a05a914d8e89e53d0e.svg";
export { ForwardRef as ReactComponent };